export default __webpack_public_path__ + "static/ttshover-54f7d4d9c6497868d4b657fabe2a9c24.png";